import { TestProps } from "../../../types";
import {
  Color,
  ERROR,
  INFO,
  PRIMARY,
  SUCCESS,
  SURFACE,
  WARNING,
} from "../../../utils";
import { AtButtonProps } from "../../atoms";

export const NOTE_COLORS = [SURFACE, SUCCESS, WARNING, INFO, PRIMARY, ERROR];

export interface MlNoteProps extends TestProps {
  title: string;
  body: string;
  userName: string;
  createdAt: string;
  modifiedAt: string;
  id: string;
  userId: string;
  action?: Pick<AtButtonProps, "text" | "onClick" | "disabled">;
  color?: Color;
  noteVariant?: "default" | "compact";
}
